
import React, { useState, useEffect } from "react";
import {
  DatePicker,
  Select,
  Button,
  Row,
  Col,
  Typography,
  Space,
  message,
  Spin,
  Table,
  Divider,
} from "antd";
import { SendOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import "antd/dist/reset.css";
import ApiService from "../EOLReportApi/ReportApiService";


const { Title, Text } = Typography;
const { Option } = Select;

const DummyOperationList = () => {
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [deviceList, setDeviceList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [groupedData, setGroupedData] = useState({});
  const [deviceCounts, setDeviceCounts] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔹 Load devices
  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const devices = await ApiService.getDevices();
        setDeviceList(devices);
      } catch (error) {
        console.error("Error fetching devices:", error);
      }
    };
    fetchDevices();
  }, []);

  // 🔹 Fetch operations
  const loadData = async () => {
    if (!fromDate || !toDate) {
      message.warning("Please select From and To Dates!");
      return;
    }

    setLoading(true);
    try {
      const response = await ApiService.getOperationsFilter(
        fromDate.format("YYYY-MM-DD"),
        toDate.format("YYYY-MM-DD"),
        selectedDevice
      );

      if (response?.status) {
        const operations = response.data.operations || [];
        const counts = response.data.device_statistics.device_counts || {};

        const grouped = {};
        operations.forEach((op) => {
          const id = op.device_id;
          if (!grouped[id]) grouped[id] = [];
          grouped[id].push(op);
        });

        setGroupedData(grouped);
        setDeviceCounts(counts);
      } else {
        message.info("No records found.");
        setGroupedData({});
        setDeviceCounts({});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Reset filters
  const resetData = () => {
    setFromDate(dayjs());
    setToDate(dayjs());
    setSelectedDevice("");
    setGroupedData({});
    setDeviceCounts({});
  };

  const formatDate = (datetime) => dayjs(datetime).format("DD-MM-YYYY");
  const formatTime = (datetime) => dayjs(datetime).format("hh:mm:ss A");

  return (
    <div style={{ background: "#FFFFFFFF", minHeight: "100vh", padding: "20px" }}>
      {/* 🔹 Filters */}
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={6}>
          <label style={labelStyle}>From Date:</label>
          <DatePicker
            style={inputStyle}
            value={fromDate}
            onChange={setFromDate}
            format="DD-MM-YYYY"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <label style={labelStyle}>To Date:</label>
          <DatePicker
            style={inputStyle}
            value={toDate}
            onChange={setToDate}
            format="DD-MM-YYYY"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <label style={labelStyle}>Device Type:</label>
          <Select
            style={inputStyle}
            value={selectedDevice}
            onChange={setSelectedDevice}
            placeholder="Select Operation"
            allowClear
          >
            {deviceList.map((device, i) => (
              <Option key={i} value={device}>
                {device}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Space style={{ marginTop: 26 }}>
            <Button
              type="primary"
              icon={<SendOutlined />}
              onClick={loadData}
              loading={loading}
              style={{ background: "#2150FDFF", border: "none" }}
            >
              Load
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={resetData}
              style={{ background: "#2150FDFF", border: "none", color: "#fff" }}
            >
              Reset
            </Button>
          </Space>
        </Col>
      </Row>

      {/* 🔹 Data Table */}
      <div
        style={{
          background: "#fff",
          marginTop: 30,
          borderRadius: 6,
          padding: 20,
          boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={4}>Operation Lists</Title>
        <Spin spinning={loading}>
          {Object.keys(groupedData).length === 0 ? (
            <Text>No data available</Text>
          ) : (
            Object.keys(groupedData).map((deviceId) => (
              <div key={deviceId} style={{ marginBottom: 40 }}>
                <Title level={5} style={{ marginBottom: 10 }}>
                  {deviceId}{" "}
                  <Text type="secondary" style={{ fontSize: 14, marginLeft: 8 }}>
                    Count: {deviceCounts[deviceId] || groupedData[deviceId].length}
                  </Text>
                </Title>
       <Table
  dataSource={groupedData[deviceId]}
  rowKey="do_id"
  pagination={false}
  bordered
  onRow={(record) => ({
    style:
      record.gap_status === "red"
        ? {
            backgroundColor: "#FF9D9DFF",
          }
        : {},
  })}
  columns={[
    {
      title: "DO ID",
      dataIndex: "do_id",
      align: "center",
    },
    {
      title: "OPERATION DATE",
      dataIndex: "op_date_time",
      align: "center",
      render: (text) => formatDate(text),
    },
    {
      title: "OPERATION TIME",
      dataIndex: "op_date_time",
      align: "center",
      render: (text) => formatTime(text),
    },
   
  ]}
/>


                <Divider />
              </div>
            ))
          )}
        </Spin>
      </div>
    </div>
  );
};

const labelStyle = { display: "block", fontWeight: 600, marginBottom: 5 };
const inputStyle = { width: "100%" };

export default DummyOperationList;